import { TabStyles } from '@tableau/widgets';
import { Style } from '../../style/StyleFunctions';

export const cellPaddingStyle: Style = {
  paddingLeft: TabStyles.Spacing.MediumSpace,
  paddingRight: TabStyles.Spacing.MediumSpace,
  height: '100%' // so empty columns select row in connect-to grids
};

export const cellDisabledStyle: Style = {
  opacity: 0.6,
};
